// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_Yxm","cls2":"common-cls2_7MI common-cls1_Yxm"};